import { HelmetProvider } from "react-helmet-async";
import { NotificationProvider, ToastProvider } from "@ir/ui";
import ErrorBoundary from "./presentation/ui/components/common/ErrorBoundary";
import AppRouter from "./routes/App.router";


import "./styles/global.scss";

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <ToastProvider position="top-center">
          <NotificationProvider>
            <AppRouter />
          </NotificationProvider>
        </ToastProvider>
      </HelmetProvider>
    </ErrorBoundary >
  );
}

export default App;
